import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from './Component';
/**
 * The link component connects between experiences and allows for traversing between VR web pages.
 * When activated via an event, the link component sends the user to a different page,
 * just like a normal web page redirect.
 * To maintain VR across pages, the following conditions must apply:
 *
 * - Your browser implements the WebXR in-VR navigation proposal.
 * Notice that is not yet part of the standard.
 * Support is experimental,
 * varies across browsers and it might require enabling manually in settings.
 * - The destination Web page listens to the window [sessiongranted] event and enters VR.
 * A-Frame experiences behave this way by default.
 * - At the moment,
 * The Oculus Browser on Quest is the only browser shipping the in-VR navigation proposal.
 *
 * @see https://aframe.io/docs/1.3.0/components/link.html
 */

export var Link = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Link, _Component);

  function Link() {
    return _Component.apply(this, arguments) || this;
  }

  return Link;
}(Component);